import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CheckPermission } from 'src/app/models/checkPermission';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';

@Directive({
  selector: '[checkPermission]',
})
export class CheckPermissionDirective implements OnInit {
  // the role the user must have
  @Input('checkPermission') set checkPermission(permission: CheckPermission) {
    this.isGranted(permission);
  }
  ngOnInit() {}
  constructor(private viewContainerRef: ViewContainerRef, private templateRef: TemplateRef<any>) {}

  private isGranted(permission: CheckPermission) {
    var userRole = null;
    let localStorageRole = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.ROLE));
    //  if no permissions in local storage and user is not admin dont show
    if (!localStorageRole) {
      this.viewContainerRef.clear();
    } else {
      userRole = localStorageRole.role.toLowerCase();
    }
    // admin can do everything
    if (userRole === 'administrator') {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if (permission.role === 'viewer' && userRole === 'viewer') {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if ((permission.role === 'editor' || permission.role === 'viewer') && (userRole === 'editor' || userRole === 'administrator')) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if (permission.role === 'erp' && userRole === 'erp') {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if ((permission.role === 'atlassian_user_manager' || permission.role === 'editor') && (userRole === 'atlassian_user_manager' || userRole === 'editor')) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
